document.addEventListener('DOMContentLoaded', function () {
  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');

          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        onSubmitHandler(evt) {
          evt.preventDefault();

          const divElement = document.querySelector('.product-variant-matching');
          if (divElement) {
            const divText = divElement.textContent;
            const product_id = evt.target.querySelector('input[name="id"]').value;
            const bracelet = document.querySelector('.featured-product-variant-radios');
            const radioButtons = document.querySelectorAll('input[name="properties[String color]"]');
            let selectedValue = '';
            radioButtons.forEach(function (radioButton) {
              if (radioButton.checked) {
                selectedValue = radioButton.value;
              }
            });

            const stringcolor = evt.target.querySelector('#bracelet-string-field');
            if (divText.includes(product_id)) {
              stringcolor.value = selectedValue;
            } else {
              stringcolor.value = '';
            }
          }

          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                fetch('/cart.js')
                  .then((response) => response.json())
                  .then((cartData) => {
                    const cartCountElement = document.getElementById('cart-icon-bubble');
                    if (cartCountElement) {
                      cartCountElement.innerText = cartData.item_count;
                      $(".header-new-cart-btn").addClass("item-added-to-cart")
                      setTimeout(()=>{
                        $(".header-new-cart-btn").removeClass("item-added-to-cart")
                      }, 1000)
                    }
                  })
                  .catch((error) => {
                    console.error('Error fetching cart count:', error);
                  });
                const dynamicCounts = document.querySelectorAll('.dynamic-count-slider');
                fetch('/cart.js', { method: 'GET' })
                  .then((response) => response.json())
                  .then((cartData) => {
                    dynamicCounts.forEach((countElement) => {
                      const productId = countElement.getAttribute('data-product-id');
                      const productInCart = cartData.items.find((item) => item.product_id == productId);
                      if (productInCart) {
                        countElement.innerText = productInCart.quantity;
                        countElement.classList.add('featured-product-count');
                      } else { 
                        countElement.innerText = '';
                        countElement.classList.remove('featured-product-count'); 
                      }
                    });
                  });
                // window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }

        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
});